import Adobe from "../providers/adobe";
import Facebook from "../providers/facebook";
import Google from "./google";

import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      consulta: [
        "Adobe.consulta",
        "Facebook.consulta_ofertaCajaAhorro",
        "Google.consulta"
      ],
      ofertaCuenta: [
        "Adobe.ofertaCuenta",
        "Facebook.ofertaCuenta_ofertaCajaAhorro",
        "Google.ofertaCuenta"
      ],
      datosPersonales: ["Adobe.datosPersonales"],
      datosLaborales: ["Adobe.datosLaborales"],
      informacionAdicional: ["Adobe.informacionAdicional"],
      identidad: ["Adobe.identidad"],
      loadingVeridas: ["Adobe.loadingVeridas"],
      biometriaOK: ["Adobe.biometriaOK"],
      configuracion: ["Adobe.configuracion"],
      contrato: ["Adobe.contrato"],
      thank: ["Adobe.graciasCajaAhorro"],
      mensaje: [
        "Adobe.mensaje",
        "Facebook.mensaje_ofertaCajaAhorro",
        "Google.mensaje"
      ],
      continuaSucursal: ["Adobe.continuaSucursal"],
      mensajeErrorSolicitudCuenta: [
        "Adobe.mensaje",
        "Facebook.mensaje_ofertaCajaAhorro",
        "Google.mensaje"
      ],
      celular: ["Adobe.celular"],
      usuarioClave: ["Adobe.usuarioClave"],
      thankOTP: ["Adobe.thankOTP"]
    },
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: [],
    [MUTATIONS.ON_INGRESO_BANCA_ONLINE]: [],
    [MUTATIONS.ON_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ON_SOLICITAR_TURNO]: ["Adobe.recibirSms"]
  },
  providers: {
    Adobe,
    Facebook,
    Google
  }
};

export default pixelDb;
